import { render, staticRenderFns } from "./ProgressLegend.vue?vue&type=template&id=4bc2f12a&scoped=true"
import script from "./ProgressLegend.vue?vue&type=script&lang=js"
export * from "./ProgressLegend.vue?vue&type=script&lang=js"
import style0 from "./ProgressLegend.vue?vue&type=style&index=0&id=4bc2f12a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc2f12a",
  null
  
)

export default component.exports